/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ThirdPartyContentTypes } from '../types/dashboardTypes';

import { isValidHttpsURL } from 'Utils';

export const openThirdPartyURLTab = (
  customContent: { type: string; value: string },
  cardData: object[]
): void => {
  let urlString: string;
  const { type: thirdPartyContentType, value } = customContent;
  // URL provided by card config
  if (thirdPartyContentType === ThirdPartyContentTypes.URL) {
    urlString = encodeURI(value);
  }
  // URL provided by dimension value
  else if (thirdPartyContentType === ThirdPartyContentTypes.DIMENSION) {
    urlString = encodeURI(cardData[0][value]);
  }

  if (isValidHttpsURL(urlString)) {
    window.open(urlString, '_blank', 'noopener noreferrer');
  } else {
    console.error('Invalid card URL protocol: ', urlString);
  }
};
